// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
import NoImage from '../../NoImage.png';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ src, width, height, alt }) => {
  const [image, setImage] = useState();

  useEffect(() => {
    setImage(src);
  }, [src]);

  return (
    <img
      src={image}
      style={{ width, height }}
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      onError={() => setImage(NoImage)}
      alt={alt}
    />
  );
};
